<!-- Start Facility Area -->
<section class="listing-categories-area bg-F7F9FB  pb-70">
    <!--data-aos="fade-up" data-aos-delay="100"-->
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-3 col-sm-6 col-md-4" *ngFor="let Content of facilityContent1;  let i = index">
                <!-- [attr.data-aos]="'fade-up'"
         [attr.data-aos-delay]="200 + (i * 100)"-->
                <div class="single-listing-category">
                    <div class="item">
                        <div class="icon">
                            <i class='{{Content.icon}}'></i>
                        </div>
                        <h3>{{Content.title}}</h3>
                        <p>{{Content.paragraph}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Facility Area -->
